import { createRouter, createWebHashHistory } from 'vue-router';
import MainPageView from '@/views/MainPageView';
import EntryView from '@/views/EntryView';
import SearchResultsView from '@/views/SearchResultsView';
import AdvancedSearchView from '@/views/AdvancedSearchView';
import IntroductionView from '@/views/IntroductionView';
import BibliographyView from '@/views/BibliographyView';
import AbbreviationsView from '@/views/AbbreviationsView';

const routes = [
  {
    path: '/',
    name: 'main',
    component: MainPageView,
  },
  {
    path: '/entry/:entryId',
    name: 'entry',
    component: EntryView,
    props: true,
  },
  {
    path: '/search-results/:op?/:simpleSearchQuery?',
    name: 'search-results',
    component: SearchResultsView,
    props: (route) => ({
      op: route.params.op,
      simpleSearchQuery: route.params.simpleSearchQuery,
      advSearchTags: route.meta.advSearchTags,
      advancedSearchQuery: route.meta.advancedSearchQuery,
    }),
  },
  {
    path: '/advanced-search',
    name: 'advanced-search',
    component: AdvancedSearchView,
    props: true,
  },
  {
    path: '/introduccio',
    name: 'introduction',
    component: IntroductionView,
  },
  {
    path: '/bibliografia',
    name: 'bibliography',
    component: BibliographyView,
  },
  {
    path: '/abreviatures',
    name: 'abbreviations',
    component: AbbreviationsView,
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 };
  },
});

export default router;
